import { type TravelApprovalLogActionEnum } from '../enums/TravelApprovalLogActionEnum'

// v1 detail logs carry name-only user objects (no id)
export interface TravelLogUserReference {
  firstName: string
  lastName: string
}

export interface TravelApprovalLogConstructor {
  id: number
  action: TravelApprovalLogActionEnum
  dateTime: ISODateString
  user: TravelLogUserReference
  nextApprover: Nullable<TravelLogUserReference>
  oldTravelBudget: number
  newTravelBudget: number
}

export class TravelApprovalLog {
  readonly id: number
  readonly action: TravelApprovalLogActionEnum
  readonly dateTime: Date
  readonly user: TravelLogUserReference
  readonly nextApprover: Nullable<TravelLogUserReference>
  readonly oldTravelBudget: number
  readonly newTravelBudget: number

  constructor(data: TravelApprovalLogConstructor) {
    this.id = data.id
    this.action = data.action
    this.dateTime = new Date(data.dateTime)
    this.user = data.user
    this.nextApprover = data.nextApprover
    this.oldTravelBudget = data.oldTravelBudget
    this.newTravelBudget = data.newTravelBudget
  }

  get userFullName(): string {
    return `${this.user.firstName} ${this.user.lastName}`
  }
}
